import { FC, ReactElement } from "react";
import { Chip, styled } from "@mui/material";
import { Visibility } from "@mui/icons-material";

import { admin_panel_settings_icon, edit_icon } from "@/constants";
import { tokens } from "@/tokens";

const AdminChip = styled(Chip)(() => ({
  backgroundColor: "#F0F1FF",
  color: "#000000",
  fontWeight: tokens.fontWeight.bold,
  padding: "8px",
}));

const ViewerChip = styled(Chip)(() => ({
  backgroundColor: tokens.border.default,
  color: "#000000",
  fontWeight: tokens.fontWeight.bold,
  padding: "8px",
}));

const EditorChip = styled(Chip)(() => ({
  backgroundColor: "rgba(151, 71, 255, 0.15)",
  color: "#000000",
  fontWeight: tokens.fontWeight.bold,
  padding: "8px",
}));

const PermissionChip: FC<{ permission: string }> = ({
  permission,
}): ReactElement => {
  if (permission === "Admin") {
    return (
      <AdminChip
        icon={<img src={admin_panel_settings_icon} width={22} />}
        label="Admin"
      />
    );
  } else if (permission === "Viewer") {
    return (
      <ViewerChip icon={<Visibility sx={{ width: "20px" }} />} label="Viewer" />
    );
  } else if (permission === "Editor") {
    return (
      <EditorChip icon={<img src={edit_icon} width={20} />} label="Editor" />
    );
  } else {
    return <Chip label={permission} />;
  }
};

export default PermissionChip;
